import { Pipe, PipeTransform } from '@angular/core';

/**
 * Computes the CSS class for the status pill based on the task status.
 *
 * Replaces `DataGridComponent.getStatusClass()`, moving the logic into a pure
 * pipe so Angular can memoize the result per input and avoid re-evaluating the
 * template function call on every change detection cycle.
 */
@Pipe({ name: 'statusClass', pure: true, standalone: false })
export class StatusClassPipe implements PipeTransform {
  transform(status: string): string {
    if (!status) return '';

    const normalizedStatus = status.toLowerCase().replace(/\s+/g, '-');

    switch (normalizedStatus) {
      case 'open':
        return 'status-open';
      case 'closed':
        return 'status-closed';
      case 'cancelled':
        return 'status-cancelled';
      case 'pending':
        return 'status-pending';
      case 'pending-client':
        return 'status-pending-client';
      case 'client-hold':
        return 'status-client-hold';
      case 'rejected':
        return 'status-rejected';
      case 'not-applicable':
        return 'status-not-applicable';
      default:
        return 'status-open'; // Default to open style for unknown statuses
    }
  }
}
